<template>
    <div class="w-full flex justify-center items-center">
        <slot>
            Brak danych
        </slot>
    </div>
</template>
